import React from 'react'
import cn from 'classnames'

import { ReactComponent as UserIcon } from '../assets/icons/user-icon.svg'

import styles from './Avatar.module.scss'

const Avatar = ({ image, className }) => {
  const classNames = cn(styles.avatar, className)
  let imageElement = <UserIcon className={styles.image} />

  return (
    <span className={classNames}>
      {imageElement}
    </span>
  )
}

export default Avatar
